import { PaymentOption } from 'apis/restaurant-inquiries';

// Options offered in the creation UI. Legacy CREDIT is intentionally absent —
// existing inquiries keep it, new ones pick a specific credit type.
export const PAYMENT_OPTION_CHOICES: Array<{ value: PaymentOption; label: string; hasDays: boolean }> = [
  { value: PaymentOption.CASH, label: 'Cash', hasDays: false },
  { value: PaymentOption.BILL_TO_BILL, label: 'Bill to Bill', hasDays: false },
  { value: PaymentOption.CREDIT_EOM, label: 'End of Month Credit', hasDays: true },
  { value: PaymentOption.CREDIT_DELIVERY, label: 'Days from Delivery Date Credit', hasDays: true },
];

// Every option that carries a creditDays value (legacy CREDIT included).
export const isCreditOption = (option?: string): boolean =>
  option === PaymentOption.CREDIT || option === PaymentOption.CREDIT_EOM || option === PaymentOption.CREDIT_DELIVERY;

// Human-readable payment label shared by the rail, detail header, and mirrors.
export const paymentLabel = (option?: string, creditDays?: number | null): string => {
  const d = creditDays || 0;
  const days = `${d} day${d === 1 ? '' : 's'}`;
  switch (option) {
    case PaymentOption.BILL_TO_BILL:
      return 'Bill to Bill';
    case PaymentOption.CREDIT_EOM:
      return `End of Month Credit — ${days}`;
    case PaymentOption.CREDIT_DELIVERY:
      return `Credit — ${days} from delivery`;
    case PaymentOption.CREDIT:
      return `Credit — ${days}`;
    default:
      return 'Cash';
  }
};
